var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
var axios = require('axios');
;
function useFetch(fetch, _a) {
    var _b = _a === void 0 ? {} : _a, onSuccess = _b.onSuccess, onError = _b.onError, initialValue = _b.initialValue;
    var _c = useState({
        loading: false,
        data: initialValue,
        errors: {},
        signal: null,
        count: 0
    }), state = _c[0], setState = _c[1];
    useEffect(function () {
        return function () {
            if (state.signal) {
                state.signal.cancel();
            }
        };
    }, [state.signal]);
    var get = function (config) {
        var signal = axios.CancelToken.source();
        setState(function (state) {
            return __assign(__assign({}, state), { signal: signal, loading: true });
        });
        config = config || {};
        config.cancelToken = signal.token;
        return fetch(config).then(successCallback).catch(errorCallback);
    };
    var post = function (data, config) {
        var signal = axios.CancelToken.source();
        setState(function (state) {
            return __assign(__assign({}, state), { signal: signal, loading: true });
        });
        config = config || {};
        config.cancelToken = signal.token;
        return fetch(data, config).then(successCallback).catch(errorCallback);
    };
    var successCallback = function (response) {
        setState(function (state) {
            return __assign(__assign({}, state), { data: response.data, loading: false, count: state.count + 1 });
        });
        if (onSuccess) {
            return onSuccess(response.data, response);
        }
    };
    var errorCallback = function (error) {
        if (!axios.isCancel(error)) {
            setState(function (state) {
                return __assign(__assign({}, state), { errors: error.response.data.errors, loading: false });
            });
            if (onError) {
                return onError(error.response.data.errors, error.response);
            }
        }
    };
    var setData = function (data) {
        setState(function (state) {
            return __assign(__assign({}, state), { data: data });
        });
    };
    return __assign(__assign({}, state), { get: get, post: post, setData: setData });
}
;
export default useFetch;
